import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Wrapper, Children, Container } from './ModalTabs.styles';
import { Tab, Tabs } from '../../../DomainTabs/DomainTabs.styles';

interface IScheduleModalTabs {
  children: ReactElement;
  activeTab: 'internal' | 'external';
  setActiveTab: (tabName: 'internal' | 'external') => void;
  isReminder?: boolean;
  show?: boolean;
}

const ScheduleModalTabs: FC<IScheduleModalTabs> = ({
  children,
  activeTab,
  setActiveTab,
  isReminder,
  show,
}) => {
  if (!show) {
    return children;
  }

  const { t } = useTranslation();

  return (
    <Wrapper>
      <Container>
        <Tabs>
          <Tab onClick={() => setActiveTab('internal')} active={activeTab === 'internal'}>
            {isReminder
              ? t('viewSurvey.schedule.remindAboutInternal')
              : t('viewSurvey.schedule.inviteToInternal')}
          </Tab>
          <Tab onClick={() => setActiveTab('external')} active={activeTab === 'external'}>
            {isReminder
              ? t('viewSurvey.schedule.remindAboutExternal')
              : t('viewSurvey.schedule.inviteToExternal')}
          </Tab>
        </Tabs>
        <Children>{children}</Children>
      </Container>
    </Wrapper>
  );
};

export default ScheduleModalTabs;
